
/**
 * 
 * @param factoid - the factoid in question
 * @param businessLinesData - all the BL data
 * 
 * returns the business name used for a label
 */
export const createChipLabel = (factoid: any, businessLinesData: any[]): string => {
  const businessLine = getBusinessLineItem(factoid, businessLinesData)
  return businessLine ? businessLine.name : ''
}

/**
 * 
 * @param factoid - the factoid in question
 * @param businessLinesData - all the BL data
 */
export const getBusinessLineItem = (factoid: any, businessLinesData: any[]) => {
  const factoidBusinessLines = factoid.business_line
  const businessLine =
    factoidBusinessLines.length > 0
      ? businessLinesData.find(
          (bizline: any) => bizline.id === factoidBusinessLines[0]
        )
      : false
  return businessLine
}

/**
 * 
 * @param selections id array of BL selections
 * @param businessLineData - all the BL data
 */
export const getBusinessLineItemsFromSelections = (
  selections: number[],
  businessLineData: any[]
) => {
  // @ts-ignore
  return businessLineData.filter(bl => selections.includes(bl.id))
}

export const getAssetClassItemsFromSelections = (selections: number[], assetClassesData: any[]) => {
  return assetClassesData
  .filter(
    (classItem: any) =>
      // @ts-ignore
      selections.includes(classItem.id)
  )
}


export const forceDownload = (blob: any, filename: string) => {
  const a = document.createElement('a')
  a.download = filename
  a.href = blob
  a.click()
}

// Used for factoids which contain things such as PDF, for user to download
export const downloadResource = (link: string, nameOfFile?: any) => {
  const url = link || 'dummylink'
  let filename: any
  if (!nameOfFile) {
    // @ts-ignore
    filename = url
      .split('\\')
      .pop()
      .split('/')
      .pop()
  }

  fetch(url, {
    headers: new Headers({
      Origin: location.origin
    }),
    mode: 'no-cors'
  })
    .then(response => response.blob())
    .then(blob => {
      const blobUrl = window.URL.createObjectURL(blob)
      forceDownload(blobUrl, filename)
    })
    .catch(e => console.error(e))
}

export const shuffle = (array: any[]) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]]; // eslint-disable-line no-param-reassign
}

  return array;
}

export const getRelatedFactoidsFromClass = (classSelections: number[], factoidData: any[]) => {
  return factoidData.filter((factoid: any) =>
    classSelections.some((classId: number) =>
      factoid.classes.includes(classId)
    )
  )
}

export const getFactoidWidth = (factoid: any) : string => {
  return factoid.acf.factoid_width === 'Double'
  ? 'item col-xs-12 col-md-8'
  : 'item col-xs-12 col-md-4'

}

export const isSimpleFactoidLayout = (factoid: any) => factoid.acf.factoid_content[0].acf_fc_layout === 'simple'

export const getFactoidsFromSelections = (factoidSelections: number[], factoidData: any[]) => {
  return factoidData.filter((factoid: any) =>
    // @ts-ignore
    factoidSelections.includes(factoid.id)
  ) 
}

export function cleanString(str: string) {
  return str.replace(/&amp;/g, '&').replace(/#038;/g, '')
}

export function cleanFactoidStrings(factoid: any) {
  const {acf, title } = factoid
  let content = acf.factoid_content[0]
  const layout = content.acf_fc_layout

  const cleanedTitle = cleanString(title.rendered)

  if (layout === 'simple') {
    content = {...content, content: cleanString(content.content)}
    return {
      ...factoid,
      title: { rendered: cleanedTitle},
      acf: {
        ...factoid.acf,
        factoid_content: [
          content
        ]
      }
    }
  } else {
    content = {
      ...content, 
      left_column: cleanString(content.left_column),
      right_column: cleanString(content.right_column)
    }
    return {
      ...factoid,
      title: { rendered: cleanedTitle},
      acf: {
        ...factoid.acf,
        factoid_content: [
          content
        ]
      }
    }
  }
}

export function cleanBusinessLineStrings(bl: any) {
  const { description, name } = bl

  return {
    ...bl,
    description: cleanString(description),
    name: cleanString(name),
  }
}

export function sortCardSizes(cards: any) {
  const singles = cards.filter((factoid: any) => factoid.acf.factoid_width === 'Single')
  const doubles = cards.filter((factoid: any) => factoid.acf.factoid_width === 'Double')

  for (let i = 1; i < doubles.length + 1; i++) {

    
    const c = doubles[i - 1];
    const p = i*3
    singles.splice(p, 0, c);
  }

  return singles
}


// WEBPACK FOOTER //
// ./src/lib/helpers.ts